export default __webpack_public_path__ + "static/media/instagram_profile_logo_01.png.4e40b61b.jpg";